export class IllumioDate extends Date {
    #getMonthString() {
        const month = this.getUTCMonth()+1;
        switch(month) {
            case 1:
                return 'Jan';
            case 2:
                return 'Feb';
            case 3:
                return 'Mar';
            case 4:
                return 'Apr';
            case 5:
                return 'May';
            case 6:
                return 'Jun';
            case 7:
                return 'Jul';
            case 8:
                return 'Aug';
            case 9:
                return 'Sep';
            case 10:
                return 'Oct';
            case 11:
                return 'Nov';
            case 12:
                return 'Dec';
        }
        return null;
    }

    #pad(number, size) {
        number = number.toString();
        while (number.length<size) {
            number = '0' + number;
        }
        return number;
    }

    toShortDateString() {
        return `${this.#getMonthString()} ${this.getUTCDate()}, ${this.getUTCFullYear()}`;
    }

    /**
     * Return yyyyMMddhhmm
     */
    toLogDateString() {
        return [ 
            this.getFullYear().toString(), 
            this.#pad(this.getMonth()+1, 2), 
            this.#pad(this.getDate(), 2),
            this.#pad(this.getHours(), 2),
            this.#pad(this.getMinutes(), 2),
        ].join('');
    }

    /**
     * @returns date in 'YYYY-MM-dd'.
     */
    toISO8601CalendarDateString() {
        return `${this.getFullYear()}-${this.#pad(this.getMonth()+1, 2)}-${this.#pad(this.getDate(), 2)}`
    }
}